<template>
  <v-container fluid v-if="getPermission('setting:view')">
    <v-layout class="pb-4">
      <v-flex>
        <h3
          class="font-weight-700 mb-0 font-size-24 custom-headline color-custom-blue"
        >
          Leave Type
        </h3>
      </v-flex>

      <div class="">
        <template v-if="getPermission('setting:update')">
          <v-btn
            depressed
            small
            class="mr-4 text-white"
            color="cyan"
            v-on:click="leaveTypeDialogOpen()"
            :disabled="pageLoading"
            :loading="pageLoading"
          >
            <span class="font-size-16 font-weight-600">Create</span>
          </v-btn>
        </template>
        <v-btn
          depressed
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </v-layout>
    <perfect-scrollbar
      :options="{ suppressScrollX: true }"
      class="scroll custom-box-top-inner-shadow"
    >
      <v-card flat class="custom-grey-border remove-border-radius page_table">
        <v-card-title class="headline grey lighten-4">
          <v-row>
            <v-col md="4" class="py-0 my-auto">
              <h3
                class="font-weight-700 custom-headline color-custom-blue"
                style="margin: 3.5px 0px"
              >
                Leave Types
              </h3>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text
          class="p-6 font-size-16"
          :class="{
            'pointer-events-none': !getPermission('setting:update'),
          }"
        >
          <v-row>
            <v-col md="12" class="pb-4">
              <v-data-table
                :headers="headers"
                :items="paginatedItems"
                class="elevation-0 alter_color custom-height"
                style="height: calc(100vh - 300px)"
                hide-default-footer
              >
                <template v-slot:item.index="{ index }">
                  <span class="text-capitalize">
                    {{ (currentPage - 1) * itemsPerPage + index + 1 }}
                  </span>
                </template>
                <template v-slot:item.name="{ item }">
                  <span class="text-capitalize">{{ item.name }}</span>
                </template>

                <template v-slot:item.min_leave="{ item }">
                  <v-chip small color="blue" text-color="white">
                    {{ item.min_leave }}
                  </v-chip>
                </template>
                <template v-slot:item.max_leave="{ item }">
                  <v-chip small text-color="white" color="indigo">
                    {{ item.max_leave }}
                  </v-chip>
                </template>
                <!-- <template v-slot:item.total_leave="{ item }">
                        <span class="text-capitalize d-flex mt-1">
                          <span class="mx-1 font-weight-700"><b> Min : </b></span>
                          <v-chip small color="blue" text-color="white"> {{ item.min_leave }} </v-chip>
                        </span>
                        <span class="text-capitalize d-flex mt-1">
                          <span class="mx-1 font-weight-700"> <b>Max : </b></span>
                          <v-chip small text-color="white" color="indigo"> {{ item.max_leave }} </v-chip> </span>
                      </template> -->
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :color="item.status == 1 ? 'green' : 'red'"
                    class="py-3 px-2 font-weight-500"
                    small
                    text-color="white"
                  >
                    {{ item.status == 1 ? "Active" : "Inactive" }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="cyan"
                    size="20"
                    v-on:click="updateLeaveTypeData(item)"
                    >mdi-pencil</v-icon
                  >

                  <v-icon
                    color="red"
                    class="ml-2"
                    size="20"
                    v-on:click="deleteLeaveType(item)"
                    >mdi-delete</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    No leave types found.
                  </p>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row
            justify="end"
            class="align-center pagination_btn listing-footer px-2"
          >
            <p class="m-0 listing-footer-count">
              Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to
              {{ Math.min(currentPage * itemsPerPage, leaveTypes.length) }}
              of {{ leaveTypes.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              total-visible="7"
              color="cyan"
              @input="handlePageChange"
            ></v-pagination>
          </v-row>
        </v-card-text>
      </v-card>
    </perfect-scrollbar>

    <!-- Create/Edit Dialog -->
    <Dialog :commonDialog="leaveTypeDialog" :dialog-width="850">
      <template v-slot:title>
        {{ leaveTypePayload.id ? "Update" : "Create" }} Leave Type
      </template>
      <template v-slot:body>
        <v-container fluid>
          <v-form
            ref="leaveTypeForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="updateLeaveType"
          >
            <v-row>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1">Name</label>
                <TextField
                  id="leave-type-name"
                  dense
                  filled
                  placeholder="Leave Type Name"
                  solo
                  flat
                  counter="50"
                  v-model="leaveTypePayload.name"
                  color="cyan"
                  :maxlength="250"
                  :rules="[
                    validateRules.required(leaveTypePayload.name, 'Name'),
                  ]"
                />
              </v-col>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1"
                  >Minimum Leave Days</label
                >
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  placeholder="Minimum Leave Days"
                  solo
                  flat
                  class="width-100"
                  type="text"
                  inputmode="numeric"
                  v-on:keypress="(e) => manageLimit(e)"
                  v-on:paste="(e) => managePaste(e)"
                  v-model.trim="leaveTypePayload.min_leave"
                  :rules="[
                    validateRules.required(
                      leaveTypePayload.min_leave,
                      'Minimum Leave Days'
                    ),
                    (value) =>
                      Number(value) >= 0 || 'The min leave must be at least 0.',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1"
                  >Maximum Leave Days</label
                >
                <v-text-field
                  dense
                  filled
                  color="cyan"
                  placeholder="Maximum Leave Days"
                  solo
                  flat
                  class="width-100"
                  type="text"
                  inputmode="numeric"
                  v-on:keypress="(e) => manageLimit(e)"
                  v-on:paste="(e) => managePaste(e)"
                  v-model.trim="leaveTypePayload.max_leave"
                  :rules="[
                    validateRules.required(
                      leaveTypePayload.max_leave,
                      'Maximum Leave Days'
                    ),
                    (value) =>
                      Number(value) <= 100 ||
                      'Maximum Leave Days cannot exceed 100',
                    (value) =>
                      Number(value) >= 1 || 'The max leave must be at least 1.',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1" color="cyan"
                  >Status</label
                >
                <v-switch
                  v-model="leaveTypePayload.status"
                  color="green"
                  :true-value="'1'"
                  :false-value="'2'"
                  class="mt-0"
                  :rules="[
                    validateRules.required(leaveTypePayload.status, 'Status'),
                  ]"
                ></v-switch>
                <!-- 
                                  :label="leaveTypePayload.status == '1' ? 'Active' : 'Inactive'"

                <v-select v-model="leaveTypePayload.status" :items="[
                  { text: 'Active', value: '1' },
                  { text: 'Inactive', value: '2' }
                ]" item-text="text" item-value="value" dense filled solo flat color="cyan" :rules="[
                  validateRules.required(leaveTypePayload.status, 'Status'),
                ]"></v-select> -->
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :loading="dataLoading"
          :disabled="dataLoading || !leaveTypeFormIsValid"
          class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text"
          v-on:click="updateLeaveType"
        >
          Save
        </v-btn>
        <v-btn
          depressed
          :disabled="dataLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="leaveTypeDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>

    <!-- Delete Confirmation Dialog -->
    <DeleteDialog :delete-dialog="deleteDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-18 font-weight-600 delete-text">
          Are you sure you want to delete this leave type?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteLoading"
          :loading="deleteLoading"
          color="red lighten-1 white--text"
          v-on:click="confirmDelete()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>

    <Dialog :commonDialog="leaveTypeInUseDialog" :dialog-width="600">
      <template v-slot:title>Cannot Delete Leave Type</template>
      <template v-slot:body>
        <v-container fluid>
          <h3 class="font-weight-500 text-center">
            Leave Type is used and cannot be deleted.
          </h3>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="leaveTypeInUseDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
import { GET, PATCH, DELETE, POST } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import DeleteDialog from "@/view/pages/partials/Delete";

export default {
  mixins: [ValidationMixin, CommonMixin],
  name: "leave-type-setting",
  data() {
    return {
      headers: [
        { text: "#", value: "index", width: "50px", sortable: false },
        { text: "Name", value: "name", width: "500px", sortable: false },
        {
          text: "Min Leave",
          value: "min_leave",
          width: "200px",
          sortable: false,
        },
        {
          text: "Max Leave",
          value: "max_leave",
          width: "200px",
          sortable: false,
        },
        { text: "Status", value: "status", width: "150px", sortable: false },
        { text: "Action", value: "actions", width: "70px", sortable: false },
      ],
      itemsPerPage: 10,
      currentPage: 1,
      formValid: true,
      leaveTypeDialog: false,
      leaveTypeInUseDialog: false,
      deleteDialog: false,
      deleteLoading: false,
      dataLoading: false,
      pageLoading: true,
      leaveTypes: [],
      leaveTypePayload: {
        id: null,
        name: null,
        max_leave: null,
        min_leave: null,
        status: "1",
      },
    };
  },
  methods: {
    leaveTypeDialogOpen() {
      this.leaveTypePayload = {
        id: null,
        name: null,
        max_leave: null,
        min_leave: null,
        status: "1",
      };
      this.leaveTypeDialog = true;
    },

    updateLeaveTypeData(item) {
      this.leaveTypePayload = {
        id: item.id,
        name: item.name,
        max_leave: item.max_leave,
        min_leave: item.min_leave,
        status: item.status,
      };
      this.leaveTypeDialog = true;
    },

    deleteLeaveType(item) {
      if (item.is_exist) {
        this.leaveTypeInUseDialog = true;
        return;
      }

      this.leaveTypePayload = item;
      this.deleteDialog = true;
    },

    confirmDelete() {
      if (this.leaveTypePayload.is_exist) return;

      this.deleteLoading = true;
      this.$store
        .dispatch(DELETE, {
          url: `leave-types/${this.leaveTypePayload.id}`,
        })
        .then(() => {
          this.deleteDialog = false;
          this.getLeaveTypes();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },

    updateLeaveType() {
      const _this = this;
      this.$refs.leaveTypeForm.validate();
      const formErrors = _this.validateForm(_this.$refs.leaveTypeForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (
        Number(_this.leaveTypePayload.min_leave) >=
        Number(_this.leaveTypePayload.max_leave)
      ) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            "Minimum Leave Days must be less than Maximum Leave Days"
          )
        );
        return false;
      }

      _this.dataLoading = true;
      const method = _this.leaveTypePayload.id ? PATCH : POST;
      const url = _this.leaveTypePayload.id
        ? `leave-types/${_this.leaveTypePayload.id}`
        : "leave-types";

      _this.$store
        .dispatch(method, {
          url: url,
          data: _this.leaveTypePayload,
        })
        .then(() => {
          this.leaveTypeDialog = false;
          _this.getLeaveTypes();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    getLeaveTypes() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "leave-types?all=true" })
        .then(({ data }) => {
          _this.leaveTypes = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    manageLimit(e) {
      if (!/^\d$/.test(e.key)) {
        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
          e.preventDefault();
        }
        return;
      }

      const inputValue = e.target.value || "";
      const start = e.target.selectionStart ?? inputValue.length;
      const end = e.target.selectionEnd ?? inputValue.length;
      const nextValue =
        inputValue.slice(0, start) + e.key + inputValue.slice(end);

      if (Number(nextValue) > 100) {
        e.preventDefault();
      }
    },

    managePaste(e) {
      const input = e.target;
      const pastedText = e.clipboardData.getData("text");
      if (!/^\d+$/.test(pastedText)) {
        e.preventDefault();
        return;
      }

      const currentValue = input.value || "";
      const start = input.selectionStart ?? currentValue.length;
      const end = input.selectionEnd ?? currentValue.length;
      const nextValue =
        currentValue.slice(0, start) +
        pastedText +
        currentValue.slice(end);

      if (Number(nextValue) > 100) {
        e.preventDefault();
      }
    },
  },

  mounted() {
    this.getLeaveTypes();
  },

  components: {
    Dialog,
    DeleteDialog,
  },

  computed: {
    leaveTypeFormIsValid() {
      const payload = this.leaveTypePayload;
      const minLeave = Number(payload.min_leave);
      const maxLeave = Number(payload.max_leave);

      return (
        !!(payload.name && payload.name.trim()) &&
        payload.min_leave !== null &&
        payload.min_leave !== "" &&
        payload.max_leave !== null &&
        payload.max_leave !== "" &&
        !!payload.status &&
        Number.isInteger(minLeave) &&
        Number.isInteger(maxLeave) &&
        minLeave >= 0 &&
        maxLeave >= 1 &&
        maxLeave <= 100
      );
    },
    pageCount() {
      return Math.ceil(this.leaveTypes.length / this.itemsPerPage);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.leaveTypes.slice(start, end);
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 19px !important;
}
</style>
